import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Play, Sparkles } from "lucide-react";
import { useRef } from "react";
import { ASSETS } from "@/data/magicalContent";

function MaskedLine({ children, delay }) {
  return <span className="ns-mask-line"><motion.span initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}>{children}</motion.span></span>;
}

export function Hero({ onWatchFinale }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imageY = useTransform(scrollYProgress, [0, 1], [0, -90]);

  return (
    <section id="home" ref={ref} className="ns-hero" data-testid="hero-section">
      <motion.img className="ns-hero-family" style={{ y: imageY }} src={ASSETS.family} alt="Niyati, Shivu and their family gathered in a magical world" data-testid="hero-family-image" initial={{ scale: 1.08 }} animate={{ scale: 1 }} transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }} />
      <div className="ns-hero-shade" aria-hidden="true" />
      <div className="ns-hero-stars" aria-hidden="true">{Array.from({ length: 34 }, (_, i) => <i key={i} style={{ left: `${(i * 29) % 100}%`, top: `${(i * 47) % 100}%`, animationDelay: `${i * -0.13}s` }} />)}</div>
      <div className="ns-hero-content">
        <motion.p className="ns-eyebrow" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}><Sparkles size={15} /> An original animated universe</motion.p>
        <h1><MaskedLine delay={0.2}>Welcome to the world of Niyati &amp; Shivu</MaskedLine></h1>
        <motion.p className="ns-hero-sub" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.72 }}>Where every story opens a new world.</motion.p>
        <motion.div className="ns-hero-actions" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.84 }}>
          <a className="ns-button ns-button-primary" href="/season-1" data-testid="start-adventure-button">Start the adventure <ArrowRight size={17} /></a>
          <button className="ns-button ns-button-ghost" data-testid="latest-episode-button" onClick={onWatchFinale}><Play size={15} fill="currentColor" /> Watch latest episode</button>
        </motion.div>
      </div>
      <div className="ns-marquee" aria-hidden="true"><div>{Array.from({ length: 4 }, (_, i) => <span key={i}>Magical worlds · Kind hearts · Flying portals · Dream delivery · Original stories · </span>)}</div></div>
    </section>
  );
}
